import React from 'react';
import { shape, bool, instanceOf, func } from 'prop-types';

import CTTableHead from './CTTableHead';
import CTTableBody from './CTTableBody';

const CTTable = ({
  definition,
  setSelectedTargets,
  updateQueryParams,
  loadMore,
  setView,
  handleAction,
}) => {
  const hasScroll = definition.data.length > 10;
  let classes = "de--table de--flex-col de--flex-col-1 de-o-hidden"
  if (hasScroll) {
    classes = `${classes} de--table--has-scroll`
  }
  return (
    <div className={classes}>
      <CTTableHead
        definition={definition}
        setSelectedTargets={setSelectedTargets}
        updateQueryParams={updateQueryParams}
      />
      <CTTableBody
        definition={{
          loading: definition.loading,
          error: definition.error,
          data: definition.data,
          response: definition.response,
          hasDefinition: definition.hasDefinition,
        }}
        setSelectedTargets={setSelectedTargets}
        loadMore={loadMore}
        setView={setView}
        handleAction={handleAction}
      />
    </div>
  );
};

CTTable.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
  setSelectedTargets: func,
  updateQueryParams: func,
  loadMore: func,
  setView: func,
  handleAction: func,
};

CTTable.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
  },
};

export default CTTable;
